<template>
  <header>
    <nav
      v-if="crumbs.length"
      class="flex items-center gap-1.5 text-[12.5px]"
      :class="inverse ? 'text-gray-400' : 'text-gray-500 dark:text-gray-400'"
      aria-label="Breadcrumb"
    >
      <span
        v-for="(crumb, index) in crumbs"
        :key="`${crumb.label}-${index}`"
        class="flex items-center gap-1.5"
      >
        <span
          v-if="index > 0"
          :class="inverse ? 'text-gray-500' : 'text-gray-400 dark:text-gray-500'"
          >/</span
        >
        <RouterLink v-if="crumb.to" :to="crumb.to" :class="crumbClass">{{
          crumb.label
        }}</RouterLink>
        <span v-else :class="crumbClass">{{ crumb.label }}</span>
      </span>
    </nav>
    <div
      class="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between"
      :class="crumbs.length ? 'mt-2' : ''"
    >
      <div class="min-w-0">
        <div class="flex min-w-0 flex-wrap items-center gap-3">
          <h1
            class="truncate text-xl font-extrabold sm:text-[26px]"
            :class="inverse ? 'text-white' : 'text-gray-900 dark:text-white'"
          >
            {{ title }}
          </h1>
          <slot name="title-extra" />
        </div>
        <p
          v-if="description"
          class="mt-1 text-[13px]"
          :class="inverse ? 'text-gray-400' : 'text-gray-500 dark:text-gray-400'"
        >
          {{ description }}
        </p>
      </div>
      <div v-if="$slots.actions" class="flex flex-wrap items-center gap-2">
        <slot name="actions" />
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: "PageHeading"
};
</script>

<script setup>
import { computed } from "vue";
import { RouterLink } from "vue-router";

const props = defineProps({
  title: {
    type: String,
    required: true
  },
  description: {
    type: String,
    default: ""
  },
  crumbs: {
    type: Array,
    default: () => []
  },
  inverse: {
    type: Boolean,
    default: false
  }
});

const crumbClass = computed(() =>
  props.inverse ? "font-semibold text-white" : "font-semibold text-gray-900 dark:text-white"
);
</script>
